import styles from "./Services.module.css";


export default function ServiceDetail({ detailedData, onBackClick }) {



  const renderContent = () => {
    if (!detailedData) {
      return (
        <div className={styles.container}>정보 없음</div>
      );
    }

    const {
      selfPublishingId,
      title,
      author,
      submitter,
      dateCreated,
      manuscriptStatus,
      bookFormat,
      numberOfCopies,
      numberOfPages,
      color,
      serviceOptions,
      manuscriptFiles,
      additionalNotes
    } = detailedData;

    return (
      <>
        <div className={styles.detailGrid}>
          <div className={styles.detailCard}>
            <h2>서비스 정보</h2>
            {/* <div className={styles.detailItem}>
              <label>Self Publishing ID</label>
              <span>{selfPublishingId}</span>
            </div> */}
            <div className={styles.detailItem}>
              <label>제출자</label>
              <span>
                {submitter}
              </span>
            </div>
            <div className={styles.detailItem}>
              <label>제출일</label>
              <span>{new Date(dateCreated).toLocaleString()}</span>
            </div>
            <div className={styles.detailItem}>
              <label>도서명(가제)</label>
              <span>{title}</span>
            </div>
            <div className={styles.detailItem}>
              <label>저자명</label>
              <span>{author}</span>
            </div>

            <div className={styles.detailItem}>
              <label>현재 상태</label>
              <span>{manuscriptStatus}</span>
            </div>
            {/* <div className={styles.actions}>
              <button
                onClick={() => handleStatusChange("APPROVED")}
                className={`${styles.actionButton} ${styles.approveButton}`}
              >
                Approve
              </button>
              <button
                onClick={() => handleStatusChange("REJECTED")}
                className={`${styles.actionButton} ${styles.rejectButton}`}
              >
                Reject
              </button>
            </div> */}
          </div>

          <div className={styles.detailCard}>
            <h2>원고 세부정보</h2>
            <div className={styles.detailItem}>
              <label>책 규격</label>
              <span>{bookFormat?.size}</span>
            </div>
            <div className={styles.detailItem}>
              <label>규격 설명</label>
              <span>{bookFormat?.description}</span>
            </div>
            <div className={styles.detailItem}>
              <label>페이지 수</label>
              <span>{numberOfPages}</span>
            </div>
            <div className={styles.detailItem}>
              <label>요청 부수</label>
              <span>{numberOfCopies}</span>
            </div>
            <div className={styles.detailItem}>
              <label>본문 컬러</label>
              <span>
                {color}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.detailCard}>
          <h2>업로드 원고 링크</h2>
          <ul className={styles.fileList}>
            {manuscriptFiles && manuscriptFiles.length > 0 ?
              <>
                {manuscriptFiles.map((file, index) => (
                  <li key={index}>
                    <a href={file.fileLink} target="_blank" rel="noopener noreferrer">
                      {file.fileName}
                    </a>
                  </li>
                ))}
              </>
              : (
                <span className={styles.emptyState}>-</span>
              )}
          </ul>
        </div>

        <div className={styles.detailCard}>
          <h2>서비스 항목</h2>
          <ul className={styles.serviceList}>
            {serviceOptions.map((service) => (
              <li key={service.serviceOption.serviceOptionId}>
                <strong>{service.serviceOption.title}</strong>{" "}
                (가격: {service.serviceOption.unitPrice.toLocaleString()}원
                {service.serviceOption.unit && ` / ${service.serviceOption.unit}`}
                , 수량: {service.quantity})
                <p>{service.serviceOption.description}</p>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.detailCard}>
          <h2>상담내용</h2>
          {additionalNotes ? (
            <span>{additionalNotes}</span>
          ) : (
            <span className={styles.emptyState}>-</span>
          )}
        </div>
      </>
    )
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <h1 className={styles.header}>출판 견적서</h1>
        <button
          onClick={onBackClick}
          className={styles.backButton}
        >
          뒤로
        </button>
      </div>

      {renderContent()}
    </div>
  );
}
